(function ($) {
    $(document).ready(function() {
        $(".slider.__home").each(function() {
            var thisElement = $(this);
            thisElement.slick({
                autoplay: true,
                autoplaySpeed: 5000,
                dots: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                responsive: [
                    {
                        breakpoint:992,
                        settings: {
                            slidesToShow: 1,
                            dots: false
                        }
                    },
                ]
            });
        })
    });

    $(document).ready(function() {
        $(".projects").each(function() {
            var thisElement = $(this);
            thisElement.slick({
                autoplay: false,
                autoplaySpeed: 5000,
                dots: false,
                infinite: true,
                slidesToShow: 5,
                slidesToScroll: 1,
                prevArrow: thisElement.closest('.inspire').find('.sliderPrevButton'),
                nextArrow: thisElement.closest('.inspire').find('.sliderNextButton'),
                arrows: true,
                responsive: [
                    {
                        breakpoint:992,
                        settings: {
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint:768,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        })
    });
})(jQuery);